import React, { useState,useRef,useEffect } from 'react';
import './style.css'
import { ReactTyped } from "react-typed";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import GetRequest from '../../service/GetRequest';
import { InputText } from 'primereact/inputtext';
import InputFieldText from '../Widgets/Inputs/InputFieldText';

const BossMagicSection = () => {
  const [open, setOpen] = useState(false);
  const [email,setEmail ] = useState("");
  const [emailError, setEmailError] = useState("");
  const [isWaitingForResponse, setIsWaitingForResponse] = useState(false);
  const vidRef=useRef();




  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };


  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };


  const handleRequestDemo = async () => {
    setEmailError("");
    // Perform validations
    let isValid = true;

    if (!email.trim()) {
      setEmailError("Email is required");
        isValid = false;
    }

    if (isValid) {
      setIsWaitingForResponse(true);
          GetRequest("v1/notification/book/demo?email="+email)
          .then(response => {
              if (!response || response === undefined) {
                console.log(response);
              } else {
                setIsWaitingForResponse(false);
                handleClickOpen();
              }
          })
          .catch(error => {
              console.error("Error sending request");
          });
      }
    };

    const footerContent = (
      <div>
          <Button label="Ok" icon="pi pi-check" onClick={() => setOpen(false)} autoFocus />
      </div>
  );


    useEffect(() => { vidRef.current.play(); },[]);


  return (
    <div id="bossMagicSection" className='BossMagicSection'>
        <div className="boss-magic-container">
                <div className="boss-magic-centralised-blocks">
                    <div className="boss-magic-title">Boss Magic</div>
                    <br/>
                    <div className="boss-magic-tag">
                    <ReactTyped
          strings={[
            "Become your own Boss",
            "Build your store app instantly",
          ]}
          typeSpeed={180}
          backSpeed={140}
          loop
        />
                        <br/></div>
                    <br/>
                    <div className='boss-demo-graphics-flex'>
                    <div className="boss-magic-description">“ Are you ready to transform your brick-and-mortar business into a digital powerhouse?
 Look no further! Introducing BOSS, the ultimate solution for creating stunning
 e-commerce mobile applications without the hassle of coding. Ready to dive into the BOSS universe?
 Watch the video to create your own app within minutes. ”</div>
 <div className="boss-magic-video">
 {/* <iframe
                ref={videoRef}
                title="boss-magic"
                src="https://www.youtube.com/embed/0ZnqRCq_WaA?rel=0&mute=1"
                width="100%"
                height="100%"
                allow="autoplay"
              ></iframe> */}
              <video loop autoPlay ref={ vidRef } 
  muted   style={{ width: '100%', height: '100%', objectFit: 'contain' }}
   >
                            <source src={require('../../assets/videos/boss-magic.mp4')} type="video/mp4" />
                        </video>
                    </div>
                    </div>
                    
 <br/>
                   
                    <br/>
                    <br/>

                    <div className="boss-magic-action"><form>
                        <input type="text" id="fname" name="fname" placeholder='Enter your email' className='book-a-demo-ip' onChange={handleEmailChange} value={email}>
                        </input></form>
                        {emailError && <div className="error-message">{emailError}</div>}
                        <div className="book-a-demo-btn" onClick={handleRequestDemo} disabled={isWaitingForResponse}>{isWaitingForResponse ?
      <div>Please wait...</div>
     : 'Book a demo' }</div>
                  {/* <div className="p-inputgroup flex-1">
                    <InputFieldText value={email} onChange={handleEmailChange} label="Email"/>
                    <Button label="Book a Demo" rounded />
                  </div> */}
                    

                <Dialog header="Request for Boss Demo Recieved" visible={open} onHide={handleClose} footer={footerContent}
                style={{ width: '50vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }}>
                <p className="m-0">
                Thankyou for your request,one of the member for Boss team will contact you shortly.
                </p>
            </Dialog>
                        </div><br/><br/>
                    <br/>
                    <br/>
                </div>
        </div> 

        </div>
  )
}

export default BossMagicSection